<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->

      <page
          :url="url"
          :form="form"
          @reset="reset"
          @select-data="handleSelectionChange"
      >
        <template slot="tableSearch">
          <el-form-item :label="$t('text.routeId')">
            <el-input v-model="form.routeId" :placeholder="$t('text.routeId')" maxlength="50"></el-input>
          </el-form-item>

          <el-form-item :label="$t('text.channel')">
            <el-select
                v-model="form.channelId"
                filterable
                :placeholder="$t('message.channelIdOrName')"
                popper-class="eloption"
            >
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option
                  v-for="channel in channelInfoList"
                  :label="channel.value + '-' + channel.name"
                  :key="channel.value"
                  :value="channel.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.exclusionChannel')">
            <el-select
                v-model="form.exclusionChannelId"
                filterable
                :placeholder="$t('message.channelIdOrName')"
                popper-class="eloption"
            >
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option
                  v-for="channel in channelInfoList"
                  :label="channel.value + '-' + channel.name"
                  :key="channel.value"
                  :value="channel.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.merchantName')">
            <el-select
                v-model="form.appId"
                filterable
                :placeholder="$t('message.chooseOne')"
                popper-class="eloption"
            >
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option
                  v-for="merchant in merchantList"
                  :label="merchant.value + '-' + merchant.name"
                  :key="merchant.value"
                  :value="merchant.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.merchantType')">
            <el-select v-model="form.merchantType" :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('option.all')" value=""/>
              <el-option :label="$t('merchantType.00')" value="00"/>
              <el-option :label="$t('merchantType.01')" value="01"/>
              <el-option :label="$t('merchantType.02')" value="02"/>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.forcedRoute')">
            <el-select v-model="form.routeStatus" :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option :label="$t('routeStatus.01')" value="01"></el-option>
              <el-option :label="$t('routeStatus.00')" value="00"></el-option>
            </el-select>
          </el-form-item>
          <br/>
          <el-form-item :label="$t('text.payType')">
            <el-select v-model="form.payType" :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option :label="$t('text.collection')" value="payin"></el-option>
              <el-option :label="$t('text.disbursement')" value="payout"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="this.$store.state.isPK" :label="$t('text.rateType')">
            <el-select v-model="form.rateType" :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option value="jazzcash"></el-option>
              <el-option value="easypaisa"></el-option>
              <el-option value="card"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="this.$store.state.isBD" :label="$t('text.rateType')">
            <el-select v-model="form.rateType" :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option value="bkash"></el-option>
              <el-option value="nagad"></el-option>
              <el-option value="rocket"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.compareType')">
            <el-select v-model="form.rateRelationalOperators" :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option :label="$t('relationalOperator.gt')" value="gt"></el-option>
              <el-option :label="$t('relationalOperator.ge')" value="ge"></el-option>
              <el-option :label="$t('relationalOperator.eq')" value="eq"></el-option>
              <el-option :label="$t('relationalOperator.le')" value="le"></el-option>
              <el-option :label="$t('relationalOperator.lt')" value="lt"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.feeRate')">
            <el-input v-model="form.rate" :placeholder="$t('text.feeRate')" maxlength="50"></el-input>
          </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button type="primary" @click="addRoute" size="small">
            {{ $t('text.addRoute') }}
          </el-button>
          <el-button
              type="primary"
              :disabled="multipleSelection.length === 0"
              @click="handleBatchClick(PAYMENT_TYPE_ID_COLLECTION)"
              size="small"
          >
            {{ $t('text.batchCollection') }}
          </el-button>
          <el-button
              type="primary"
              :disabled="multipleSelection.length === 0"
              @click="handleBatchClick(PAYMENT_TYPE_ID_PAYMENT)"
              size="small"
          >
            {{ $t('text.batchDisbursement') }}
          </el-button>
          <el-button
              type="primary"
              @click="confirmBackupOrRestore($t('message.confirmRouteBackup'), true)"
              size="small"
              :loading="loading"
          >
            {{ $t('text.routeBackup') }}
          </el-button>
          <el-button
              type="primary"
              @click="confirmBackupOrRestore($t('message.confirmRouteRestore'), false)"
              size="small"
              :loading="loading"
          >
            {{ $t('text.routeRestore') }}
          </el-button>
        </template>

        <template slot="tableColumn">
          <el-table-column type="selection" width="50" align="center">
          </el-table-column>

          <el-table-column
              prop="merName"
              :label="$t('text.merchantName')"
              width="150px"
              align="center"
              fixed
          >
          </el-table-column>

          <template v-if="this.$store.state.isPK">
            <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

            <el-table-column
                prop="paymentRateConfig"
                :label="$t('text.collectionJCFeeRate')"
                width="120px"
                align="center"
            >
              <template slot-scope="scope">
                {{ JSON.parse(scope.row.paymentRateConfig || '{}').jazzcash || '' }}
              </template>
            </el-table-column>

            <el-table-column
                prop="paymentRateConfig"
                :label="$t('text.collectionEPFeeRate')"
                width="120px"
                align="center"
            >
              <template slot-scope="scope">
                {{ JSON.parse(scope.row.paymentRateConfig || '{}').easypaisa || '' }}
              </template>
            </el-table-column>

            <el-table-column
                prop="transferRateConfig"
                :label="$t('text.disbursementJCFeeRate')"
                width="120px"
                align="center"
            >
              <template slot-scope="scope">
                {{ JSON.parse(scope.row.transferRateConfig || '{}').jazzcash || '' }}
              </template>
            </el-table-column>

            <el-table-column
                prop="transferRateConfig"
                :label="$t('text.disbursementEPFeeRate')"
                width="120px"
                align="center"
            >
              <template slot-scope="scope">
                {{ JSON.parse(scope.row.transferRateConfig || '{}').easypaisa || '' }}
              </template>
            </el-table-column>

            <el-table-column
                prop="transferRateConfig"
                :label="$t('text.disbursementCardFeeRate')"
                width="130px"
                align="center"
            >
              <template slot-scope="scope">
                {{ JSON.parse(scope.row.transferRateConfig || '{}').card || '' }}
              </template>
            </el-table-column>

            <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>
          </template>

          <el-table-column width="150px"
                           prop="collectionAmount"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.collectionAmount')"
                           sortable
                           :sort-method="(a, b) => Number(a.collectionAmount) - Number(b.collectionAmount)"
                           align="center"/>

          <el-table-column
              prop="merchantType"
              :label="$t('text.merchantType')"
              :formatter="$formatter.formatMerchantType"
              width="80px"
              align="center"
          >
          </el-table-column>

          <el-table-column
              prop="routeStatus"
              :label="$t('text.forcedRoute')"
              :formatter="$formatter.formatRouteStatus"
              width="80px"
              align="center"
          >
          </el-table-column>

          <el-table-column
              prop="channelName"
              :label="$t('text.collectionChannel')"
              width="200px"
              align="center"
          >
          </el-table-column>

            <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>
            <template v-if="this.$store.state.isPK">
                <el-table-column
                    prop="paymentChannelConfig"
                    :label="$t('text.collectionJCChannel')"
                    width="120px"
                    align="center"
                >
                  <template slot-scope="scope">
                    {{ JSON.parse(scope.row.paymentChannelConfig || '{}').jazzcash || '' }}
                  </template>
                </el-table-column>

              <el-table-column
                    prop="paymentChannelConfig"
                    :label="$t('text.collectionJCQrChannel')"
                    width="120px"
                    align="center"
                >
                  <template slot-scope="scope">
                    {{ JSON.parse(scope.row.paymentChannelConfig || '{}').jazzcashQr || '' }}
                  </template>
                </el-table-column>

                <el-table-column
                    prop="paymentChannelConfig"
                    :label="$t('text.collectionBkJCChannel')"
                    width="140px"
                    align="center"
                >
                  <template slot-scope="scope">
                    {{ JSON.parse(scope.row.paymentChannelConfig || '{}').jazzcashBackup || '' }}
                  </template>
                </el-table-column>

                <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

                <el-table-column
                    prop="paymentChannelConfig"
                    :label="$t('text.collectionEPChannel')"
                    width="120px"
                    align="center"
                >
                  <template slot-scope="scope">
                    {{ JSON.parse(scope.row.paymentChannelConfig || '{}').easypaisa || '' }}
                  </template>
                </el-table-column>

                <el-table-column
                    prop="paymentChannelConfig"
                    :label="$t('text.collectionEPQrChannel')"
                    width="120px"
                    align="center"
                >
                  <template slot-scope="scope">
                    {{ JSON.parse(scope.row.paymentChannelConfig || '{}').easypaisaQr || '' }}
                  </template>
                </el-table-column>

                <el-table-column
                    prop="paymentChannelConfig"
                    :label="$t('text.collectionBkEPChannel')"
                    width="140px"
                    align="center"
                >
                  <template slot-scope="scope">
                    {{ JSON.parse(scope.row.paymentChannelConfig || '{}').easypaisaBackup || '' }}
                  </template>
                </el-table-column>

                <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

                <el-table-column
                    prop="paymentChannelConfig"
                    :label="$t('text.collectionCardChannel')"
                    width="120px"
                    align="center"
                >
                  <template slot-scope="scope">
                    {{ JSON.parse(scope.row.paymentChannelConfig || '{}').card || '' }}
                  </template>
                </el-table-column>

                <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

                <el-table-column
                    prop="paymentChannelConfig"
                    :label="$t('text.collectionBillChannel')"
                    width="120px"
                    align="center"
                >
                  <template slot-scope="scope">
                    {{ JSON.parse(scope.row.paymentChannelConfig || '{}').bill || '' }}
                  </template>
                </el-table-column>

                <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>
            </template>
            <template v-else-if="this.$store.state.isBD">
                <el-table-column
                    prop="paymentChannelConfig"
                    :label="$t('text.collectionBKashChannel')"
                    width="120px"
                    align="center"
                >
                  <template slot-scope="scope">
                    {{ JSON.parse(scope.row.paymentChannelConfig || '{}').bKash || JSON.parse(scope.row.paymentChannelConfig || '{}').bkash || '' }}
                  </template>
                </el-table-column>

                <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

                <el-table-column
                    prop="paymentChannelConfig"
                    :label="$t('text.collectionNagadChannel')"
                    width="120px"
                    align="center"
                >
                  <template slot-scope="scope">
                    {{ JSON.parse(scope.row.paymentChannelConfig || '{}').nagad || '' }}
                  </template>
                </el-table-column>

                <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

                <el-table-column
                    prop="paymentChannelConfig"
                    :label="$t('text.collectionRocketChannel')"
                    width="130px"
                    align="center"
                >
                  <template slot-scope="scope">
                    {{ JSON.parse(scope.row.paymentChannelConfig || '{}').rocket || '' }}
                  </template>
                </el-table-column>

                <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>
            </template>

          <el-table-column width="150px"
                           prop="disbursementAmount"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.disbursementAmount')"
                           sortable
                           :sort-method="(a, b) => Number(a.disbursementAmount) - Number(b.disbursementAmount)"
                           align="center"/>

          <el-table-column
              prop="withdrawChannelName"
              :label="$t('text.disbursementChannel')"
              width="200px"
              align="center"
          >
          </el-table-column>

          <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

          <template v-if="this.$store.state.isPK">
            <el-table-column
                prop="transferChannelConfig"
                :label="$t('text.disbursementJCChannel')"
                width="120px"
                align="center"
            >
              <template slot-scope="scope">
                {{ JSON.parse(scope.row.transferChannelConfig || '{}').jazzcash || '' }}
              </template>
            </el-table-column>

            <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

            <el-table-column
                prop="transferChannelConfig"
                :label="$t('text.disbursementEPChannel')"
                width="120px"
                align="center"
            >
              <template slot-scope="scope">
                {{ JSON.parse(scope.row.transferChannelConfig || '{}').easypaisa || '' }}
              </template>
            </el-table-column>

            <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

            <el-table-column
                prop="transferChannelConfig"
                :label="$t('text.disbursementBankChannel')"
                width="120px"
                align="center"
            >
              <template slot-scope="scope">
                {{ JSON.parse(scope.row.transferChannelConfig || '{}').card || '' }}
              </template>
            </el-table-column>

            <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>
          </template>

          <template v-if="this.$store.state.isBD">
            <el-table-column
                prop="transferChannelConfig"
                :label="$t('text.disbursementBKashChannel')"
                width="120px"
                align="center"
            >
              <template slot-scope="scope">
                {{ JSON.parse(scope.row.transferChannelConfig || '{}').bKash || JSON.parse(scope.row.transferChannelConfig || '{}').bkash || '' }}
              </template>
            </el-table-column>

            <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

            <el-table-column
                prop="transferChannelConfig"
                :label="$t('text.disbursementNagadChannel')"
                width="120px"
                align="center"
            >
              <template slot-scope="scope">
                {{ JSON.parse(scope.row.transferChannelConfig || '{}').nagad || '' }}
              </template>
            </el-table-column>

            <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

            <el-table-column
                prop="transferChannelConfig"
                :label="$t('text.disbursementRocketChannel')"
                width="130px"
                align="center"
            >
              <template slot-scope="scope">
                {{ JSON.parse(scope.row.transferChannelConfig || '{}').rocket || '' }}
              </template>
            </el-table-column>

            <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>
          </template>

          <el-table-column
              prop="createUser"
              :label="$t('text.creator')"
              width="170px"
              align="center"
          >
          </el-table-column>

          <el-table-column
              prop="createTime"
              :label="$t('text.creationTime')"
              :formatter="$formatter.formatDate"
              width="160px"
              align="center"
          >
          </el-table-column>

          <el-table-column
              prop="updateUser"
              :label="$t('text.updatedBy')"
              width="170px"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.updateUser">{{ row.updateUser }}</div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
              prop="updateTime"
              :label="$t('text.updateTime')"
              width="160px"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.updateTime">
                {{ $formatter.formatDate(null, null, row.updateTime, null) }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
              fixed="right"
              align="center"
              :label="$t('text.actions')"
              width="100"
          >
            <template slot-scope="scope">
              <!-- <el-button
                type="text"
                size="small"
                @click="updateEdit(scope.row, 1)"
                >查看</el-button
              > -->
              <el-button
                  type="primary"
                  size="mini"
                  plain
                  @click="updateEdit(scope.row, 0)"
              >{{ $t('text.edit') }}
              </el-button
              >
              <!-- <el-button
                type="text"
                size="small"
                @click="deleteAccount(scope.row)"
                >删除</el-button
              > -->
            </template>
          </el-table-column>
        </template>
      </page>
      <pk_route_config_inf_edit
          :show.sync="showDialog"
          :value="value"
          :action="action"
          v-if="this.$store.state.isPK"
      ></pk_route_config_inf_edit>

      <bd_route_config_inf_edit
          :show.sync="showDialog"
          :value="value"
          :action="action"
          v-if="this.$store.state.isBD"
      ></bd_route_config_inf_edit>

      <PkBatchRouteUpdate
          :show.sync="showBatchDialog"
          :value="strMultipleSelection"
          :action="action"
          v-if="this.$store.state.isPK"
      />

      <BdBatchRouteUpdate
          :show.sync="showBatchDialog"
          :value="strMultipleSelection"
          :action="action"
          v-if="this.$store.state.isBD"
      />
    </div>
  </div>
</template>

<script>
import Page from "@/components/Page.vue";
import PkRouteConfigInfoEdit from "./routeConfigInfo/PkRouteConfigInfoEdit.vue";
import PkBatchRouteUpdate from "./routeConfigInfo/PkBatchRouteUpdate.vue";
import BdBatchRouteUpdate from "./routeConfigInfo/BdBatchRouteUpdate.vue";
import {
  PAYMENT_TYPE_ID_COLLECTION,
  PAYMENT_TYPE_ID_PAYMENT
} from "@/utils/Constant";
import BdRouteConfigInfoEdit from "@/views/route/routeConfigInfo/BdRouteConfigInfoEdit.vue";

export default {
  name: "route",
  components: {
    page: Page,
    pk_route_config_inf_edit: PkRouteConfigInfoEdit,
    bd_route_config_inf_edit: BdRouteConfigInfoEdit,
    PkBatchRouteUpdate: PkBatchRouteUpdate,
    BdBatchRouteUpdate: BdBatchRouteUpdate
  },
  data() {
    return {
      PAYMENT_TYPE_ID_COLLECTION,
      PAYMENT_TYPE_ID_PAYMENT,
      timeDate: [],
      multipleSelection: [],
      strMultipleSelection: [],
      url: "/routeConfigInfo/selectList",
      action: "",
      form: {
        routeId: "",
        appId: "",
        productId: "",
        channelId: "",
        exclusionChannelId: "",
        merchantType: "",
        routeStatus: "",
        startDate: "",
        endDate: "",
        payType: "",
        rateType: "",
        rateRelationalOperators: "",
        rate: ""
      },
      showDialog: false,
      showBatchDialog: false,
      formLabelWidth: "100px",
      formData: null,
      value: {},
      agtList: [],
      channelList: [],
      productList: [],
      merchantList: [],
      channelInfoList: [],
      loading: false
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.strMultipleSelection = this.multipleSelection.map(
          ({routeId}) => routeId
      );
    },
    timeChange(e) {
      console.log(this.timeDate);
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    reset() {
      this.timeDate = [];
    },
    // deleteAccount(row) {
    //   let routeId = row.routeId;
    //   console.log(routeId);
    //   this.axios
    //       .get("/routeConfigInfo/routeChannelInfoDel", {
    //         params: {
    //           routeId: routeId
    //         }
    //       })
    //       .then((res) => {
    //         if (res.code === 200) {
    //           this.$bus.$emit("refresh"); //通知刷新
    //           this.$notify({
    //             title: this.$t('text.prompt'),
    //             message: res.msg,
    //             type: "success"
    //           });
    //         } else {
    //           this.$notify.error({
    //             title: this.$t('text.prompt'),
    //             message: res.msg
    //           });
    //         }
    //       });
    // },
    updateEdit(row, num) {
      if (num === 1) {
        this.$bus.$emit("refreshButton", false); //查看
      }
      if (num === 0) {
        this.$bus.$emit("refreshButton", true); //编辑
        this.$bus.$emit("isDisabled", true);
      }
      this.action = "edit";
      this.value = Object.assign({}, row);
      this.showDialog = true;
    },
    addRoute() {
      let row = {};
      row.num = "2";
      this.value = row;
      this.action = "add";
      this.$bus.$emit("isDisabled", false); //编辑
      this.$bus.$emit("refreshButton", true); //编辑
      this.showDialog = true;
    },
    handleBatchClick(productId) {
      this.action = `batch_${productId}`;
      this.$bus.$emit("isDisabled", false); //编辑
      this.$bus.$emit("refreshButton", true); //编辑
      this.showBatchDialog = true;
    },
    backupRouteAll() {
      this.loading = true;
      let url = "/routeConfigInfo/routeConfigInfoBackupAll";
      axios.post(url, {sysId: "1000"}).then((res) => {
        if (res.code === 200) {
          this.$notify({
            title: this.$t('text.prompt'),
            message: res.msg,
            type: "success"
          });
        } else {
          this.$notify.error({
            title: this.$t('text.prompt'),
            message: res.msg
          });
        }
        this.loading = false;
      });
    },
    restoreRouteAll() {
      this.loading = true;
      let url = "/routeConfigInfo/routeConfigInfoRestoreAll";
      this.axios.post(url, {sysId: "1000"}).then((res) => {
        if (res.code === 200) {
          this.$notify({
            title: this.$t('text.prompt'),
            message: res.msg,
            type: "success"
          });
          this.$bus.$emit("refresh"); //通知刷新
        } else {
          this.$notify.error({
            title: this.$t('text.prompt'),
            message: res.msg
          });
        }
        this.loading = false;
      });
    },
    confirmBackupOrRestore(message, isBackup) {
      this.$confirm(
          message,
          {
            confirmButtonText: this.$t('text.confirm'),
            cancelButtonText: this.$t('text.cancel'),
            type: "warning",
          }
      )
          .then(() => {
            if (isBackup) {
              this.backupRouteAll();
            } else {
              this.restoreRouteAll();
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t('text.cancel'),
            });
          });
    },
  },
  mounted() {
    this.$bus.$on("setAgtList", (agtList) => {
      this.agtList = agtList;
    });
    this.$bus.$on("setChannelList", (channelList) => {
      this.channelList = channelList;
    });
    this.$bus.$on("setProductList", (productList) => {
      this.productList = productList;
    });
  },
  created() {
    this.$axios
        .get("/merchant/selectListForOption", {params: {hasAgent: 1}})
        .then((res) => {
          this.merchantList = res.data;
        });

    this.$axios
        .get("/routeChannelInfo/selectListForOption", {params: {}})
        .then((res) => {
          this.channelInfoList = res.data;
        });
  }
};
</script>
